import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';

const DocumentSequenceForm = ({ sequenceData, callback, createDocSequence, loading, user, currentActionType, UpdateDocSequence, entityName }) => {

  const [documentSequence, setDocumentSequence] = useState(null);
  const [currentSequence, setCurrentSequence] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (sequenceData) {
      setDocumentSequence(sequenceData.seq_prefix);
      setCurrentSequence(sequenceData.seq_counter);
    }
  }, [sequenceData]);

  const createDocumentSeq = () => {
    setFormSubmitted(true);
    const payload = {
      body: {
        seq_prefix: documentSequence,
        seq_counter: currentSequence,
        tenant_id: user?.tenant_info?.tenant_id,
        entity_name: entityName,
      },
    }
    if (
      !documentSequence || (currentSequence === null || currentSequence === undefined || currentSequence === '')
    ) {
      notification.open({
        type: 'error',
        message: `please enter all the required fields`,
        duration: 4,
        placement: 'top',
      });
    } else {
      if (currentActionType === 'update') {
        payload.body.seq_id = sequenceData.seq_id;
        UpdateDocSequence(payload, (data) => {
          callback()
        })
      } else {
        createDocSequence(payload, (data) => {
          callback()
        })
      }
    }
  };

  return (
    <>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3FormInput
            name="prefix"
            type="text"
            containerClassName="orgInputContainer update-sequence-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => {
              setDocumentSequence(event.target.value);
            }}
            value={documentSequence}
            showError={formSubmitted && !documentSequence}
            label="Document Prefix"
            maxlength="20"
            required
            disabled={loading}
          />
          <H3FormInput
            name="current sequence"
            type="number"
            containerClassName="orgInputContainer update-sequence-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => {
              setCurrentSequence(event.target.value);
            }}
            value={currentSequence}
            showError={formSubmitted && (currentSequence === null || currentSequence === undefined || currentSequence === '')}
            label="Current Sequence"
            maxlength="10"
            required
            disabled={loading}
            noDecimal
          />
        </div>
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Save"
            onClick={createDocumentSeq}
            isLoading={loading}
            disabled={loading}
            style={{
              width: '100px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </>
  );
};

export default DocumentSequenceForm;
